import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useT } from '../lib/i18n';
import { api, setSession } from '../lib/api';
import { useConfig } from '../lib/queries';
import { Wallet } from '@phosphor-icons/react';
import { Screen } from '../components/ui';

declare global {
  interface Window {
    onTelegramAuth?: (user: Record<string, string | number>) => void;
  }
}

/** Shown only in a plain browser without a session; inside Telegram initData signs every request. */
export function Login() {
  const t = useT();
  const config = useConfig();
  const host = useRef<HTMLDivElement>(null);
  const qc = useQueryClient();

  useEffect(() => {
    if (!config.data || !host.current) return;
    window.onTelegramAuth = (user) => {
      void api<{ token: string }>('/auth/telegram-login', { body: user }).then((r) => {
        setSession(r.token);
        void qc.invalidateQueries();
      });
    };
    const s = document.createElement('script');
    s.src = 'https://telegram.org/js/telegram-widget.js?22';
    s.async = true;
    s.setAttribute('data-telegram-login', config.data.botUsername);
    s.setAttribute('data-size', 'large');
    s.setAttribute('data-radius', '14');
    s.setAttribute('data-onauth', 'onTelegramAuth(user)');
    s.setAttribute('data-request-access', 'write');
    host.current.replaceChildren(s);
  }, [config.data, qc]);

  return (
    <Screen className="login">
      <span className="login__mark" aria-hidden="true">
        <Wallet size={40} weight="fill" />
      </span>
      <h1 className="login__title">Onyx</h1>
      <p className="login__body">{t['common.signInBody']}</p>
      <div ref={host} className="login__widget" aria-label={t['common.signIn']} />
      {config.data && (
        <a className="slab slab--primary slab--block" href={`https://t.me/${config.data.botUsername}`}>
          <span className="slab__label">@{config.data.botUsername}</span>
        </a>
      )}
    </Screen>
  );
}
